module.exports = __webpack_public_path__ + "78a425fa51e66dd6970513fca6bcc9ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/header_folders.png
// module id = 46
// module chunks = 0 1 2 3 4